import { render, staticRenderFns } from "./purchase_add.vue?vue&type=template&id=ec316566&scoped=true&"
import script from "./purchase_add.vue?vue&type=script&lang=js&"
export * from "./purchase_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec316566",
  null
  
)

export default component.exports